import { UseFormReturn } from "react-hook-form";

import type { UpdateJobFormValues } from "./JobUpdateModal";
import { FormButtonGroup } from "@/components/form/FormButtonGroup";
import { FormTextInput } from "@/components/form/FormTextInput";
import { Form } from "@/components/ui/form";

import {
  jobBottleneckOptions,
  jobBottleNeckToIcon,
  jobHealthOptions,
  jobHealthToBackgroundColor,
  jobHealthToDotColor,
  jobHealthToHoverBackgroundColor,
} from "@/lib/constants";
import { JobHealth } from "@/types";

const jobHealthDotIcons: Record<string, React.ElementType> = Object.fromEntries(
  Object.values(JobHealth).map((health) => [
    health,
    () => (
      <span
        className={`h-2 w-2 rounded-full ${jobHealthToDotColor[health]}`}
      />
    ),
  ]),
);

// Maps each health value to the className applied when that option is selected in FormButtonGroup.
// Overrides the default "bg-primary-300" with health-specific background, hover, and border styles.
const jobHealthSelectedClassName: Record<string, string> =
  Object.fromEntries(
    Object.values(JobHealth).map((health) => [
      health,
      `${jobHealthToBackgroundColor[health]} ${jobHealthToHoverBackgroundColor[health]} border-transparent`,
    ]),
  );

export const JobUpdateForm = ({
  form,
}: {
  form: UseFormReturn<UpdateJobFormValues>;
}) => {
  const render = () => {
    return (
      <Form {...form}>
        <form className="mt-2 flex flex-col gap-4">
          <FormTextInput
            fieldName="description"
            form={form}
            label="Status Description"
            placeholder="Brief update on current status (5-10 words)..."
          />
          <FormButtonGroup
            fieldName="health"
            form={form}
            label="Health Status"
            options={jobHealthOptions}
            valueToSelectedClassName={jobHealthSelectedClassName}
            valueToIconMap={jobHealthDotIcons}
          />
          <FormButtonGroup
            fieldName="bottleneck"
            form={form}
            label="Current Bottleneck"
            options={jobBottleneckOptions}
            valueToIconMap={jobBottleNeckToIcon}
          />
        </form>
      </Form>
    );
  };

  return render();
};
